import { useEffect, useState } from 'react';
import { Button, Header, Segment } from 'semantic-ui-react';
import Notification from './Notification';
import { observer } from 'mobx-react-lite';
import './styles.css';
import { useStore } from '../../app/stores/store';
import CardBox from './CardBox';
import { v4 as uuid } from 'uuid';
import { useNavigate, useParams } from 'react-router-dom';
import { mastercommunication } from '../../app/stores/CommunicationSettingForDynamicDashboard/types';
import { toast } from 'react-toastify';
function CommunicationSetting() {
  const history = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { ApiStore, CommunicationSettingStore } = useStore();
  const { notification, communcation, getmasterCommunication } =
    CommunicationSettingStore;
  const { metadataGetApi } = ApiStore;
  const [dropdown, setDropDown] = useState<{
    value: string;
    list: {
      key: string;
      value: string;
      text: string;
    }[];
  }>({
    value: '',
    list: [],
  });
  const [notificationList, setNotificationList] = useState<any[]>([]);
  const [metadataComponent, setMetadataComponent] = useState<any[]>([]);
  const [metadataValue, setMetadataValue] = useState<string[]>([]);
  const [communicationMsgStr, setCommunicationMsgStr] = useState<any>();
  const [communicationSubStr, setCommunicationSubStr] = useState<any>();
  useEffect(() => {
    if (id) {
      metadataGetApi(id).then((res: any) => {
        setMetadataComponent(res);
        setDropDown({
          ...dropdown,
          list: res,
        });
      });
      communcation(id, {}, 'masterApi').then((Response) => {
        if (Response?.data?.length > 0) {
          communcation(
            Response?.data?.[Response?.data?.length - 1]?.id,
            {},
            'showApi',
          ).then((Response) => {
            setCommunicationMsgStr(Response?.data?.message);
            setCommunicationSubStr(Response?.data?.subject);
            const notification = Response?.data?.notifications;
            notification.forEach((item: any) => {
              const formattedNotification = `${item.id}/${item.notificationOccurance}/${item.metadataTemplateId}/${item.notificationCondition}/${item.conditionValue}`;
              notificationList.push(formattedNotification);
            });
          });
        } else {
          communcation('', {}, 'addApi', { masterId: id });
        }
      });
    }
    // eslint-disable-next-line
  }, []);
  const historyBack = () => {
    history(-1);
  };
  const handleDropdownList = (e: any, data: any) => {
    setDropDown({
      ...dropdown,
      value: data.value,
    });
    const generatedID = uuid();
    const concatenatedValue =
      generatedID + '/' + e.currentTarget.textContent + '/' + data.value;
    // Clear the previous data and set the state to the new value
    setMetadataValue([concatenatedValue]);
  };
  const handleAddItem = () => {
    setDropDown({ ...dropdown, value: '' });
    setNotificationList((oldState) => {
      const updatedValues = metadataValue[0]?.split('/')[3]
        ? metadataValue.map((value) => value.split('/').slice(0, -1).join('/'))
        : metadataValue;
      const filteredValues = updatedValues.filter(
        (value) => !oldState.some((item) => item.includes(value.split('/')[1])),
      );
      return [...oldState, ...filteredValues];
    });
    const [id, metadataTemplateId, notificationOccurance] =
      metadataValue[0]?.split('/') || [];
    const params = {
      id,
      metadataTemplateId,
      notificationCondition: '',
      conditionValue: '',
      notificationOccurance,
    };
    notification(getmasterCommunication[0]?.id, params, 'addApi');
  };
  const handleSubmit = () => {
    const transformedNotifications = notificationList.map((item: string) => {
      const [
        id,
        notificationOccurance,
        metadataTemplateId,
        notificationCondition,
        conditionValue,
      ] = item.split('/');
      return {
        id,
        notificationOccurance,
        metadataTemplateId,
        notificationCondition,
        conditionValue,
      };
    });
    getmasterCommunication.forEach((item: mastercommunication) => {
      item.masterId = id || '';
      item.notifications = transformedNotifications;
      item.isNotification = true;
    });
    if (getmasterCommunication[0]?.userRolesId) {
      communcation('', getmasterCommunication[0], 'updateApi');
    } else {
      toast.error('Kindly Fill User Role...');
    }
  };
  return (
    <div>
      <header>
        <Header
          style={{ flex: '1', marginRight: '20px' }} // Allow the header to take up remaining space
          icon="rocketchat"
          size="huge"
          dividing
          as="h1"
          content={'Communication Setting'}
          sub
          color="grey"
        />
        <div className="split-button">
          <div></div>
          <Button.Group
            floated="right"
            style={{
              backgroundColor: '#93ddbe',
              height: '40px',
              marginTop: '10px',
              marginRight: '10px',
            }}
          >
            <Button
              negative
              onClick={() => {
                communcation(getmasterCommunication[0]?.id, {}, 'deleteApi');
                historyBack();
              }}
            >
              Delete
            </Button>
            <Button.Or text={'or'} />{' '}
            <Button onClick={() => historyBack()}>Cancel</Button>
            <Button.Or text={'or'} />
            <Button
              type="submit"
              content="Submit"
              positive
              //Submit
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Button.Group>
        </div>
      </header>
      <Segment style={{ margin: '15px' }}>
        <Notification
          dropdown={dropdown}
          setDropDown={setDropDown}
          notificationList={notificationList}
          handleAddItem={handleAddItem}
          handleDropdownList={handleDropdownList}
          setNotificationList={setNotificationList}
        />
        <br />
        <CardBox
          metadataComponent={metadataComponent}
          communicationMsgStr={communicationMsgStr}
          communicationSubStr={communicationSubStr}
          // commScheme={getmasterCommunication || []}
        />
      </Segment>
    </div>
  );
}

export default observer(CommunicationSetting);
